import {
  Box,
  SortProvider,
  ModalProvider,
  SearchProvider,
  PaginationProvider,
  DropdownOptions,
  TooltipPopup,
} from 'dash-ui';

import Header from 'flow-components/Header/Header';
import Container from 'flow-components/Container/Container';

import ExternalSalesPageHeader from './components/ExternalSalesPageHeader/ExternalSalesPageHeader';
import ExternalSalesPageTable from './components/ExternalSalesPageTable/ExternalSalesPageTable';

const ExternalSaleTeamsPage = () => (
  <Box w="100%">
    <Header />
    <Container>
      <PaginationProvider>
        <SortProvider>
          <SearchProvider>
            <ModalProvider>
              <Box w="100%">
                <DropdownOptions />
                <TooltipPopup />
                <ExternalSalesPageHeader />
                <ExternalSalesPageTable />
              </Box>
            </ModalProvider>
          </SearchProvider>
        </SortProvider>
      </PaginationProvider>
    </Container>
  </Box>
);

export default ExternalSaleTeamsPage;
